export default __webpack_public_path__ + "static/media/img_20.2829fdc6.JPG";